// extracted by mini-css-extract-plugin
export default {"wrapper":"Xz-z","button":"Yz-z","alternate":"Zz-z","disabled":"_z-z","paymentWarning":"aA-z","fadeIn":"bA-z"};